/** @format */

import Button from "@mui/material/Button";

const MSButton = ({ text, children, icon, backgroundColor, clickAction, disabled }: any) => {
  return (
    <Button
      size="small"
      disabled={disabled}
      sx={{
        paddingLeft: `30px`,
        paddingRight: `30px`,
        height: `50px`,
        borderRadius: `50px`,
        textTransform: `inherit`,
        backgroundColor: backgroundColor,
        font: `normal normal 500 20px/80px Raleway`,
        "&:hover, &:active": {
          backgroundColor: backgroundColor,
          color: "#fff",
        },
      }}
      variant="contained"
      startIcon={icon}
      onClick={clickAction}
    >
      {text || children}
    </Button>
  );
};

export default MSButton;
